import { Tabs, Tab, Box } from "@mui/material";
import { Link, useLocation } from "react-router-dom";

const LaamTopNav = () => {
  const location = useLocation();

  const routes = [
    { path: "/laam/products", label: "Products" },
    { path: "/laam/orders", label: "Orders" },
  ];

  const currentTab = routes.findIndex((route) =>
    location.pathname.startsWith(route.path)
  );

  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
      <Tabs value={currentTab !== -1 ? currentTab : false}>
        {routes.map((route, index) => (
          <Tab
            key={index}
            label={route.label}
            component={Link}
            to={route.path}
          />
        ))}
      </Tabs>
    </Box>
  );
};
export default LaamTopNav;
